const colors = {
  brand: {
    primary: '#00BDAA',
    gray400: '#A0AEC0',
    textColor: '#525252',
    blue: '#37446f',
    white: '#FFF',
    black: '#000',
  },
}
export default colors
